var _circle, _path, _circle2, _circle3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 34.397,
    stroke: "#8F55FF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.333 16.26C85.426 7.391 72.343 2 58 2 27.072 2 2 27.072 2 58a55.91 55.91 0 0 0 3.187 18.667m15.001 22.64C30.151 108.432 43.425 114 58 114c30.928 0 56-25.072 56-56 0-6.904-1.25-13.517-3.535-19.624",
    stroke: "#8F55FF",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.162,
    cy: 22.581,
    r: 7.594,
    stroke: "#8F55FF",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.88,
    cy: 92.462,
    r: 7.594,
    stroke: "#8F55FF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.564 24.017c-9.39 10.78-22.538 39.467 0 67.966M59.436 24.017c9.39 10.78 22.538 39.467 0 67.966",
    stroke: "#8F55FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.154 44.12c-9.566.722-35.02 1.733-60.308 0M88.154 73.795c-9.566-.722-35.02-1.734-60.308 0",
    stroke: "#8F55FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesDelivery);
export default __webpack_public_path__ + "static/media/features-delivery.4333e9a9522ea82fe30d573dc9c3eac0.svg";
export { ForwardRef as ReactComponent };